export const companyTypes = (t) => [
  {
    label: t("CLIENT"),
    value: 1,
  },
  {
    label: t("SUPPLIER"),
    value: 2,
  },
  {
    label: t("CARRIER"),
    value: 3,
  },
  {
    label: t("CENTER"),
    value: 4,
  },
];

export const statusOptions = [
  {
    label: "NO_FILTER",
    value: "no_filter",
  },
  {
    label: "ACTIVE",
    value: 1,
  },
  {
    label: "INACTIVE",
    value: 2,
  },
];

export const serviceOptions = (t) => [
  {
    label: t("NO_FILTER"),
    value: "no_filter",
  },
  {
    label: t("EVACUATION"),
    value: "EVACUATION",
  },
  {
    label: t("DELIVERY"),
    value: "DELIVERY",
  },
];

export const countryOptions = [
  {
    label: "England",
    value: 1,
  },
  {
    label: "France",
    value: 2,
  },
  {
    label: "Poland",
    value: 3,
  },
  {
    label: "Belgium",
    value: 4,
  },
  {
    label: "Netherlands",
    value: 5,
  },
  {
    label: "Germany",
    value: 6,
  },
  {
    label: "Spain",
    value: 7,
  },
  {
    label: "Switzerland",
    value: 8,
  },
];

export const categoryOptions = [
  {
    label: "SOIL",
    value: 1,
  },
  {
    label: "MATERIAL",
    value: 2,
  },
  {
    label: "WASTE",
    value: 3,
  },
  {
    label: "TRANSPORT",
    value: 4,
  },
];

export const subCategoryOptions = [
  {
    label: "Polluted Soil",
    value: 1,
  },
  {
    label: "Non-polluted",
    value: 2,
  },
  {
    label: "Natural",
    value: 3,
  },
  {
    label: "Recycle",
    value: 4,
  },
  {
    label: "Unknown Soil",
    value: 5,
  },
  {
    label: "Sans préférence",
    value: 6,
  },
  {
    label: "Hazardous",
    value: 7,
  },
  {
    label: "Non Hazardous",
    value: 8,
  },
  {
    label: "Asbestos",
    value: 10,
  },
];

export const siteStatus = (t) => [
  {
    label: t("SITE_STATUS_DRAFT"),
    value: 11,
  },
  {
    label: t("SITE_STATUS_QUOTATION"),
    value: 1,
  },
  {
    label: t("SITE_STATUS_QUOTE_SENT"),
    value: 2,
  },
  {
    label: t("SITE_STATUS_LOST_PARTNER"),
    value: 6,
  },
  {
    label: t("SITE_STATUS_LOST_CLIENT"),
    value: 5,
  },
  {
    label: t("SITE_STATUS_LOST_HESUS"),
    value: 4,
  },
  {
    label: t("SITE_STATUS_WON"),
    value: 3,
  },
  {
    label: t("SITE_STATUS_PENDING"),
    value: 9,
  },
  {
    label: t("SITE_STATUS_CANCELED"),
    value: 10,
  },
  {
    label: t("SITE_STATUS_READY_TO_START"),
    value: 12,
  },
  {
    label: t("SITE_STATUS_IN_PROGRESS"),
    value: 13,
  },
  {
    label: t("SITE_STATUS_PAUSED"),
    value: 14,
  },
  {
    label: t("SITE_STATUS_FINISHED"),
    value: 15,
  },
];

export const leadStatusAll = (t) => [
  {
    label: t("SELECT_ALL"),
    value: "*",
  },
  {
    label: t("LEAD_STATUS_TO_PROCESS"),
    value: 0,
  },
  {
    label: t("LEAD_STATUS_REJECTED"),
    value: 1,
  },
  {
    label: t("LEAD_STATUS_IN_PROGRESS"),
    value: 2,
  },
  {
    label: t("LEAD_STATUS_PROCESSED"),
    value: 4,
  },
];
export const leadStatus = (t) => [
  {
    label: t("LEAD_STATUS_TO_PROCESS"),
    value: 0,
  },
  {
    label: t("LEAD_STATUS_REJECTED"),
    value: 1,
  },
  {
    label: t("LEAD_STATUS_IN_PROGRESS"),
    value: 2,
  },
  {
    label: t("LEAD_STATUS_PROCESSED"),
    value: 4,
  },
];

export const leadStatusForList = {
  0: "LEAD_STATUS_TO_PROCESS",
  1: "LEAD_STATUS_REJECTED",
  2: "LEAD_STATUS_IN_PROGRESS",
  4: "LEAD_STATUS_PROCESSED",
};

export const companyTypeOptions = [
  {
    name: "CLIENT",
    id: 1,
  },
  {
    name: "HAULIER",
    id: 2,
  },
  {
    name: "SUPPLIER",
    id: 3,
  },
  {
    name: "CENTRE",
    id: 4,
  },
];

export const daysOptions = [
  {
    name: "MONDAY",
    id: "Monday",
  },
  {
    name: "TUESDAY",
    id: "Tuesday",
  },
  {
    name: "WEDNESDAY",
    id: "Wednesday",
  },
  {
    name: "THURSDAY",
    id: "Thursday",
  },
  {
    name: "FRIDAY",
    id: "Friday",
  },
  {
    name: "SATURDAY",
    id: "Saturday",
  },
];

export const solutionStatus = (t) => [
  {
    label: t("SOLUTION_STATUS_SELECTED"),
    value: 4,
  },
  {
    label: t("SOLUTION_STATUS_TRANSPORT_QUOTATION"),
    value: 5,
  },
  {
    label: t("SOLUTION_STATUS_QUOTED"),
    value: 6,
  },
  {
    label: t("SOLUTION_STATUS_VALIDATED"),
    value: 7,
  },
  {
    label: t("SOLUTION_STATUS_VALIDATED_KO"),
    value: 8,
  },
  {
    label: t("SOLUTION_STATUS_VALIDATED_OUT_KO"),
    value: 9,
  },
];

export const enquiryTypeOptions = (t) => [
  {
    label: t("ENQUIRY_STATUS_TO_PROCESS"),
    value: 1,
  },
  {
    label: t("ENQUIRY_STATUS_QUOTATION"),
    value: 2,
  },
  {
    label: t("ENQUIRY_STATUS_DELETED"),
    value: 4,
  },
  {
    label: t("ENQUIRY_STATUS_CANCELED"),
    value: 6,
  },
  {
    label: t("ENQUIRY_STATUS_QUOTED"),
    value: 5,
  },
  {
    label: t("ENQUIRY_STATUS_REQUOTATION"),
    value: 9,
  },
];

export const siteStatusColor = {
  11: "#0A4986",
  1: "#00AEEA",
  2: "#008395",
  6: "#D9D9D9",
  5: "#E83F1E",
  4: "#E83F1E",
  3: "#32A728",
  9: "#F08046",
  10: "#D9D9D9",
  12: "#EFCA06",
  13: "#FF981E",
  14: "#712DC9",
  15: "#0A6800",
};

export const purchaseOrderStatus = (t) => [
  {
    label: t("PURCHASE_ORDER_STATUS_PENDING"),
    value: 0,
  },
  {
    label: t("PURCHASE_ORDER_STATUS_SENT"),
    value: 1,
  },
  {
    label: t("PURCHASE_ORDER_STATUS_CANCELLED"),
    value: 2,
  },
  {
    label: t("PURCHASE_ORDER_STATUS_DELETED"),
    value: 3,
  },
];

export const invoiceDocumentTypes = (t) => [
  { value: 1, label: t("CLIENT_INVOICING_DOCUMENT_TYPE_INVOICE") },
  { value: 2, label: t("CLIENT_INVOICING_DOCUMENT_TYPE_CREDIT_NOTE") },
];

export const filterInvoiceTypes = (t) => [
  { value: 1, label: t("CLIENT_INVOICING_TYPE_INTERCO") },
  { value: 2, label: t("CLIENT_INVOICING_TYPE_REGULARISATION") },
  { value: 3, label: t("CLIENT_INVOICING_TYPE_MANUAL") },
  { value: 4, label: t("CLIENT_INVOICING_TYPE_OPERATIONS") },
];

export const formInvoiceTypes = (t) => [
  { value: 1, label: t("CLIENT_INVOICING_INVOICE_TYPE_INTERCO") },
  { value: 2, label: t("CLIENT_INVOICING_INVOICE_TYPE_ADJUSTMENT") },
];

